import React from 'react'
import SkeletonLoder from '../common/skeletonLoder';
import PropTypes from "prop-types";
import { DropDownWrapper } from '../../containers/Education/styles';
import { DropdownContent } from '../UserDashboard/styles';
import {ImageUrl} from '../../utils/constants';
import { Heading } from './style';
import { FlexWrapper, NewChampionsCardNew,EventCard, NewVideoPlayerNew, NewContentV2New} from '../MainEvents/RecommendEventVideos/styles'
import Thumbnail from '../Thumbnail';
import { useEffect } from 'react';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { ArchiveArticles, GetLaunchedArticle } from '../../redux/constants/apiConstants';
import { useHistory } from "react-router-dom";
import { ArchiveCategoryIcon, EditIconNew } from '../../utils/icons';
import CommonModalNew from '../common/CommonModal/CommonModalNew';

function ArticleComponent({categories,wellnessLoading}) {
  
  const history = useHistory();  

  const [launchedArticles, setLaunchedArticles] = React.useState([]);
  const [archivePopupOpen, setArchivePopupOpen] = React.useState(false);
  const [selectedArticle, setSelectedArticle] = React.useState(null);

  useEffect(()=>{
    FetchRecentLaunchedData();
  },[])
  
  
  const FetchRecentLaunchedData = async()=>{
    
    try {
      const res = await fetchApi(GetLaunchedArticle, "GET");
      if(res.status === 'success'){
        setLaunchedArticles(res.data[0].data)
       
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }




  const ArchiveCatgories = async()=>{
    const categoryId = selectedArticle?.article_id;
    
    try {
      const res = await fetchApi(ArchiveArticles + "/" + categoryId, "DELETE");
      if(res.status === 'success'){
        toast.success(res.message);
        FetchRecentLaunchedData();  
        setLaunchedArticles(res.data[0].data);
      
       
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  const handleArchivePopup = (item) => {
    setArchivePopupOpen(true);
    setSelectedArticle(item);
  }

  const handleArchivePopupClose = () => {
    setArchivePopupOpen(false);
  }



  const handleConfirmArchive = () => {
    ArchiveCatgories();
    setArchivePopupOpen(false);
  }


  const handleArticleClick = (item) => {
    history.push({pathname:`/wellness-resources/article-details/${item.article_id}`,
      state : {libraryPage:"Articles"}});
  };

  const handleEdit = (item) => {
    history.push({pathname:`/wellness-resources/edit-article/${item.article_id}`, state:{page: "Articles"}})
  }



  return (
    <div>
      {wellnessLoading ? <SkeletonLoder width="1248px" height="100px" style={{ marginTop:"20px" }} /> : categories?.length ? <DropDownWrapper>
        {categories?.map((data, index) => (
          <DropdownContent key={index}
            /*onClick={() => history.push({pathname:`/wellness-resources/${data?.type}`,state:{categoryData:data}})}*/
            onClick={() => history.push({pathname:`/company/wellness/category-content`,
              state: {categoryData:data,contentType: "articles"}})}
          > 
            <img src={`${ImageUrl}/${data?.image}`} />
            <div className="listContent">{data?.category_name}</div>
          </DropdownContent>))}
      </DropDownWrapper> : null}

      <Heading>Recently Launched Articles</Heading>


      <FlexWrapper>
        {launchedArticles
          .map((item) => (
            <NewChampionsCardNew key={item.article_id}  >
              <EventCard isMarginBottom={"0px"} borderRadius={"6px 6px 0 0"} isWidth={"398px"}>
                  
                <NewVideoPlayerNew onClick={() => handleArticleClick(item)} style={{ cursor: 'pointer' }}>
                  <Thumbnail
                    style={{ cursor: 'pointer',marginTop:"8px"}} 
                    src={`${ImageUrl}/${item?.article_image}`}
                    alt={'img'}
                  
                  />
                </NewVideoPlayerNew>
                <NewContentV2New newPadding={'newPadding'} isPadding={"16px 8px 8px 8px"}  style={{ minHeight: 'auto',backgroundColor:"#FEFEFE",borderRadius:'0px 0px 8px 8px' }}>
                  <div className='firstContainer'>
                    <div className='name' title={item?.title}>
                      {item?.title}
                    </div>
                  </div>
                  <div className="imageContainer">
                    <span
                      className="icon archive"
                      onClick={() => handleArchivePopup(item)}
                      title="Archive"
                    >
                      {ArchiveCategoryIcon()}
                    </span>
                    <span
                      className="icon edit"
                      onClick={() => handleEdit(item)}
                      title="Edit"
                    >
                      {EditIconNew()}
                    </span>
                  </div>
                </NewContentV2New>
              </EventCard>
            </NewChampionsCardNew>
          ))}
      </FlexWrapper>
      {archivePopupOpen && <CommonModalNew
        show={archivePopupOpen}
        icon={ArchiveCategoryIcon("#184A61")}
        title="Archive Article"
        description="Are you sure you want to Archive this article?"
        subDescription="You can view the archived data in archive tab of wellness resources"
        onCancel={handleArchivePopupClose}
        onConfirm={handleConfirmArchive}
        cancelText="Keep Article"
        confirmButtonText="Archive"
        buttonIcon={ArchiveCategoryIcon("white")}
        modalHeight="261px"
        confirmButtonWidth="200px"
      />}
      



      
    </div>
  )
}

ArticleComponent.propTypes={
  wellnessLoading: PropTypes.bool.isRequired,
  categories: PropTypes.array.isRequired

}

export default ArticleComponent;
